import React, { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';

import Breadcrumbs from '../../components/Breadcrumbs';
import PageHeader from '../../components/PageHeader';
import DashLeads from './DashLeads';
import DashCustomers from './DashCustomers';

export default function Home() {
  const [activeTab, setActiveTab] = useState('leads');

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Breadcrumbs title="Dashboards" />
      <PageHeader title="Dashboards" />
      <section className="mb-3 mb-lg-5">
        <Tabs
          activeKey={activeTab}
          onSelect={(eventKey) => setActiveTab(eventKey)}
          className="mb-5"
        >
          <Tab eventKey="leads" title="Leads">
            <DashLeads />
          </Tab>
          <Tab eventKey="customers" title="Clientes">
            <DashCustomers />
          </Tab>
        </Tabs>
      </section>
    </Container>
  );
}
